module.exports = __webpack_public_path__ + "static/media/CONAD.cbc9520e.svg";